import styled from 'styled-components';

export const Container = styled.div`
  overflow: auto;
  height: 100%;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  thead {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  th {
    text-align: left;
    background: #fff;
  }

  td {
    padding: 21px 0;
    color: #1a1b1c;
    font-size: 16px;
  }

  tr + tr {
    border-top: 1px solid #d0dae3;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Profile = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 16px;
`;

export const Menu = styled.img`
  cursor: pointer;
`;

export const Head = styled.div`
  background: #fafbfd;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #758ca3;
  font-size: 12px;

  &.member {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding-left: 7px;
  }

  &.center {
    padding-left: 7px;
  }

  &.menu {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const MenuHeader = styled.div`
  visibility: hidden;
  font-size: inherit;
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
`;

interface IStatusCircle {
  status: 'expired' | 'accepted' | 'sent';
}

export const StatusCircle = styled.div<IStatusCircle>`
  background: ${({ status }) => {
    if (status === 'expired') {
      return '#EA1212';
    }

    if (status === 'accepted') {
      return '#249D0E';
    }

    return '#E3E3E3';
  }};
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-right: 9px;
`;
